export default "__VITE_ASSET__BJcTfYh4__"